// Who gets the site. Phones are not supported (owner decision 2026-11-04); detection is by
// capability and window shape, not by the user-agent string (iPadOS reports itself as a Mac).

export type Support = "ok" | "phone" | "rotate";

/** Long side of the window under this many CSS pixels counts as a phone. */
export const MIN_LONG_SIDE = 1000;

interface UAData {
  mobile?: boolean;
}

export function support(win: Window = window): Support {
  const ua = (win.navigator as Navigator & { userAgentData?: UAData }).userAgentData;
  if (ua?.mobile === true) return "phone";
  const w = win.innerWidth;
  const h = win.innerHeight;
  if (Math.max(w, h) < MIN_LONG_SIDE) return "phone";
  // A tablet held upright (touch is its primary pointer, even with a trackpad attached): big
  // enough, but the film and the calendar are landscape.
  if (h > w && win.matchMedia("(pointer: coarse)").matches) return "rotate";
  return "ok";
}

export const NOTICE: Record<Exclude<Support, "ok">, { title: string; body: string }> = {
  phone: {
    title: "Julkalenderspel spelas på dator",
    body: "Spelen från 2014 behöver mus och tangentbord, och den här sidan är byggd för en datorskärm. Öppna julkalenderspel.se på en dator.",
  },
  rotate: {
    title: "Vänd skärmen",
    body: "Julkalenderspel är byggt för liggande skärm. Vänd plattan på sidan, så startar resan.",
  },
};
